const fileTrashBrowserPreview = (file) => {
    if (file?.preview) {
        URL.revokeObjectURL(file.preview)
        file.preview = null
    }
    return file
}

export default fileTrashBrowserPreview